
export const numberFormat = ({number,decimal=0,style='decimal'}) => {
  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
    ? localStorage.getItem("organization")
    : "{}"
  );
  const currency = orgData?.country?.currency || 'USD';
  const local = orgData?.country?.local || 'en-US';
  return new Intl.NumberFormat(local, {
    style: style,
    currency: currency,
    ...(style === "decimal" ? {minimumFractionDigits: decimal} : {}),
    maximumFractionDigits: decimal
  }).format(+number || 0);
  
}
 

export const getCurrency = () => {
  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
    ? localStorage.getItem("organization")
    : "{}"
  );
  const currency = orgData?.country?.currencySymbol || '$';
  return currency;
}